import React from 'react';
import { Card, Button, Input } from 'antd';

const { TextArea } = Input;

interface NotesCardProps {
  value: string;
  onChange: (value: string) => void;
  onSave?: () => void;
  showSaveButton?: boolean;
}

export const NotesCard: React.FC<NotesCardProps> = ({
  value,
  onChange,
  onSave,
  showSaveButton = false,
}) => {
  return (
    <Card
      title="Notes"
      className="user-detail-notes-card"
      style={{ borderRadius: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}
    >
      <TextArea
        placeholder="Add a note about this user..."
        value={value}
        onChange={e => onChange(e.target.value)}
        rows={4}
        style={{ borderRadius: 8, marginBottom: showSaveButton ? 12 : 0 }}
      />
      {showSaveButton && onSave && (
        <Button type="primary" onClick={onSave} style={{ borderRadius: 8 }}>
          Save Note
        </Button>
      )}
    </Card>
  );
};
